import { resolveTestimonialVideo } from './testimonialVideo';

function matchesFormation(testimonial, formation) {
  if (!testimonial || !formation) return false;
  const formationId = formation.id || formation.slug;
  if (testimonial.courseId && formationId && testimonial.courseId === formationId) {
    return true;
  }
  if (testimonial.formation && formation.title && testimonial.formation === formation.title) {
    return true;
  }
  return false;
}

/** Participant testimonials from home section linked to a formation page. */
export function getLinkedParticipantTestimonials(formation, getContent) {
  const list = getContent('home.participantTestimonials')?.testimonials || [];
  return list.filter((item) => matchesFormation(item, formation));
}

/** Embedded formation reviews + linked participant testimonials for #avis. */
export function getFormationReviewsDisplay(formation, getContent) {
  const embedded = (formation?.reviews || []).map((review) => ({
    ...review,
    type: review.type || 'text',
    source: 'formation',
  }));

  const linked = getLinkedParticipantTestimonials(formation, getContent).map((item) => ({
    name: item.name,
    rating: item.rating || 5,
    date: item.date || '',
    comment: item.text || '',
    type: item.type || 'text',
    youtube_url: item.youtube_url,
    youtube_id: item.youtube_id,
    video_thumbnail: item.video_thumbnail,
    source: 'participant',
  }));

  return [...embedded, ...linked];
}

export function isVideoReview(review) {
  if (!review) return false;
  if (review.type === 'video') return true;
  return Boolean(resolveTestimonialVideo(review));
}
